import List from '../../../../components/Purchasing/VendorQuotes/Lines/List'
import VendorQuotesLinesModal from '../../../../components/Purchasing/VendorQuotes/Lines/VendorQuotesLinesModal'
import React, { Fragment } from 'react'

function VendorQuotesLines(props) {
  return (
    <Fragment>
      <VendorQuotesLinesModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

export default VendorQuotesLines
